export default "__VITE_ASSET__hVoTfPEx__"